import { useEffect, useState } from 'react';
import ConsentForm from '../forms/ConsentForm';
import { IntakeForm } from '../IntakeForm';
import { MentalStatusExam } from '../MentalStatusExam';
import CounselingRecordForm from '../forms/CounselingRecordForm';
import { SafetyContract } from '../SafetyContract';
import TerminationForm from '../forms/TerminationForm';
import { AlertCircle, ArrowLeft } from "lucide-react";
import useSession from '../../../hooks/useSession';

const StepContent = ({
  activeStep,
  sessionData,
  onSubmit,
  showSafetyForm,
  onSafetySubmit,
  handleEndCounseling,
  isNewClient,
  actualSessionId,
  showTerminationForm,
  onTerminationSubmit,
  // Draft-related props
  handleFormChange,
  hasUnsavedChanges,
  lastAutoSave,
  // New props for back navigation
  onBack,
  canGoBack
}) => {
  const commonFormProps = {
    sessionData,
    onSubmit,
    handleFormChange,
    hasUnsavedChanges,
    lastAutoSave
  };

  // Helper function to render back button for forms
  const renderBackButton = (showBack = true) => {
    if (!showBack || !canGoBack) return null;
    
    return (
      <div className="mb-4">
        <button
          onClick={onBack}
          className="flex items-center px-3 py-2 text-gray-600 hover:text-gray-800 hover:bg-gray-100 rounded-md transition-colors"
        >
          <ArrowLeft className="h-4 w-4 mr-2" />
          Back
        </button>
      </div>
    );
  };

  if (showSafetyForm) {
    return (
      <div className="p-4">
        {renderBackButton()}
        <SafetyContract
          {...commonFormProps}
          initialData={sessionData?.safety}
          onSubmit={onSafetySubmit}
          sessionId={actualSessionId}
        />
      </div>
    );
  }

  if (showTerminationForm) {
    return (
      <div className="p-4">
        {renderBackButton()}
        <TerminationForm
          {...commonFormProps}
          initialData={sessionData?.termination}
          onSubmit={onTerminationSubmit}
          sessionId={actualSessionId}
        />
      </div>
    );
  }

  const renderContent = () => {
    // For continuing clients, only show counseling record
    if (!isNewClient) {
      return (
        <div className="p-4 bg-white rounded-lg shadow">
          <h2 className="text-xl font-semibold mb-4">On-Going Counseling Report</h2>
          <CounselingRecordForm
            sessionId={actualSessionId}
            onSuccess={(data) => onSubmit("record", data)}
            onTerminate={handleEndCounseling}
            isNewClient={isNewClient}
          />
        </div>
      );
    }

    // For new clients, show the step-based forms (consent, intake, mental status)
    return renderNewClientForms();
  };

  // Helper to render forms for new clients based on active step
  const renderNewClientForms = () => {
    const formContent = (() => {
      switch (activeStep) {
        case "consent":
          return (
            <ConsentForm
              {...commonFormProps}
              initialData={sessionData?.consent}
              onSubmit={(data) => onSubmit("consent", data)}
            />
          );
        case "intake":
          return (
            <IntakeForm
              {...commonFormProps}
              initialData={sessionData?.intake}
              onSubmit={(data) => onSubmit("intake", data)}
              sessionId={actualSessionId}
            />
          );
        case "mentalStatus":
          return (
            <MentalStatusExam
              {...commonFormProps}
              initialData={sessionData?.mentalStatusExam}
              onSubmit={(data) => onSubmit("mentalStatusExam", data)}
              sessionId={actualSessionId}
            />
          );
        default:
          return (
            <div className="p-4 bg-red-50 border border-red-200 rounded-lg">
              <p className="text-red-600">Invalid step selected: {activeStep}</p>
            </div>
          );
      }
    })();

    return (
      <div className="p-4">
        {renderBackButton()}
        {formContent}
      </div>
    );
  };

  return (
    <div className="w-full">
      {renderContent()}
    </div>
  );
};

export default StepContent;


// const StepContent = ({
//   activeStep,
//   sessionData,
//   onSubmit,
//   showSafetyForm,
//   onSafetySubmit,
//   handleEndCounseling,
//   isNewClient,
//   actualSessionId,
//   showTerminationForm,
//   onTerminationSubmit,
//   // Draft-related props
//   handleFormChange,
//   hasUnsavedChanges,
//   lastAutoSave
// }) => {
//   const commonFormProps = {
//     sessionData,
//     onSubmit,
//     handleFormChange,
//     hasUnsavedChanges,
//     lastAutoSave
//   };
//   if (showSafetyForm) {
//     return (
//       <SafetyContract
//         {...commonFormProps}
//         initialData={sessionData?.safety}
//         onSubmit={onSafetySubmit}
//         sessionId={actualSessionId}
//       />
//     );
//   }

//   if (showTerminationForm) {
//     return (
//       <TerminationForm
//       {...commonFormProps}
//         initialData={sessionData?.termination}
//         onSubmit={onTerminationSubmit}
//         sessionId={actualSessionId}
//       />
//     );
//   }

//   const renderContent = () => {
//     // For continuing clients, only show counseling record
//     if (!isNewClient) {
//       return (
//         <div className="p-4 bg-white rounded-lg shadow">
//           <h2 className="text-xl font-semibold mb-4">On-Going Counseling Report</h2>
//           <CounselingRecordForm
//             sessionId={actualSessionId}
//             onSuccess={(data) => onSubmit("record", data)}
//             onTerminate={handleEndCounseling}
//             isNewClient={isNewClient}
//           // The key fix: Pass the session hook directly to preserve all its methods and state
//           // This ensures actualSessionId is available inside the form
//           />
//         </div>
//       );
//     }

//     // For new clients, show the step-based forms (consent, intake, mental status)
//     return renderNewClientForms();
//   };

//   // Helper to render forms for new clients based on active step
//   const renderNewClientForms = () => {

//     switch (activeStep) {
//       case "consent":
//         return (
//           <ConsentForm
//           {...commonFormProps}
//             initialData={sessionData?.consent}
//             onSubmit={(data) => onSubmit("consent", data)}

//           />
//         );
//       case "intake":
//         return (
//           <IntakeForm
//           {...commonFormProps}
//             initialData={sessionData?.intake}
//             onSubmit={(data) => onSubmit("intake", data)}
//             sessionId={actualSessionId}
//           />
//         );
//       case "mentalStatus":
//         return (
//           <MentalStatusExam
//           {...commonFormProps}
//             initialData={sessionData?.mentalStatus}
//             onSubmit={(data) => onSubmit("mentalStatus", data)}
//             sessionId={actualSessionId}
//           />
//         );
//       default:
//         return (
//           <div className="p-4 bg-red-50 border border-red-200 rounded-lg">
//             <p className="text-red-600">Invalid step selected: {activeStep}</p>
//           </div>
//         );
//     }
//   };

//   // Show safety form if it's enabled (can be for both new and continuing clients)
//   if (showSafetyForm) {
//     return (
//       <SafetyContract
//         initialData={sessionData?.safety}
//         onSubmit={onSafetySubmit}
//       />
//     );
//   }

//   return (
//     <div className="w-full p-4">
//       {renderContent()}
//     </div>
//   );
// };

// export default StepContent;